import { Page, Navbar, NavTitle, f7 } from 'framework7-react';
import { BottomTabBar } from './BottomTabBar';
import '@styles/statusReview.css';
import { getCurrentUser, getDocument, addDocument } from '../firebase';
import statusReviewImage from '../assets/statusreview.png';

function StatusReview() {
  const handleSendEmail = async () => {
    const user = await getCurrentUser()
    if (!user) return

    f7.dialog.preloader('Sending Email...')

    let name = user.displayName || user.email?.split('@')[0] || 'User'
    let email = user.email || 'unknown@example.com'

    const cached = localStorage.getItem('userInfo')
    if (cached) {
      try {
        const info = JSON.parse(cached) as {
          fullName?: string
          email?: string
        }
        name = info.fullName || name
        email = info.email || email
      } catch {
        console.warn('Invalid cached user info')
      }
    }

    try {
      const snap = await getDocument(`users/${user.uid}`)
      if (snap.exists()) {
        const data = snap.data() as { fullName?: string; email?: string }
        if (data.fullName) name = data.fullName
        if (data.email) email = data.email
        localStorage.setItem('userInfo', JSON.stringify(data))
      }
    } catch (err) {
      console.error('Error fetching user info', err)
      try {
        // getDocFromCache not available on native plugin
      } catch (cacheErr) {
        console.error('Cache fetch failed', cacheErr)
      }
    }

    try {
      await addDocument('statusReviewEmails', {
        name,
        email,
        createdAt: Date.now(),
      })
      f7.dialog.close()
      f7.dialog.alert('Email sent.')
    } catch (err) {
      f7.dialog.close()
      console.error('Error saving request', err)
      f7.toast
        .create({
          text: 'Error sending email. Try again',
          closeTimeout: 3000,
          position: 'top',
          cssClass: 'error-toast',
        })
        .open()
    }
  }

  return (
    <Page name="status-review" className="status-review-page">
      <Navbar className="no-outline">
        <NavTitle>Status Review</NavTitle>
      </Navbar>

      <div className="content-container">
        <h1 className="status-review-title">Status Review</h1>
        <p className="status-review-subtitle">
          Submit unlimited status reviews.
        </p>
        <p className="status-review-note">
          *Exclusive access to DealSaver members
        </p>

        <div className="status-review-image-container">
          <img
            src={statusReviewImage}
            alt="Status Review"
            className="status-review-image"
          />
        </div>

        <button
          className="status-review-button"
          onClick={handleSendEmail}
        >
          Send the link to my Email
        </button>
      </div>

      <BottomTabBar />
    </Page>
  );
}

export default StatusReview;
